import dayjs from "dayjs";


export const showHyphen=(value:any)=>{
    if(value===null ||
        value===undefined ||
        value === "" ||
        value ==="null"){
            return "-";
        }
        return value

}



export const formttedDate = (date: any) => {
  if (!date) return "-";
  return dayjs(date).format("DD MMM YYYY");
};


































  